

import React from 'react';
import { useTranslation } from 'react-i18next';

interface TldrBoxProps {
  content: string;
}

const TldrBox: React.FC<TldrBoxProps> = ({ content }) => {
  const { t } = useTranslation('common');
  return (
    <div className="p-6 rounded-2xl border-l-4 border-brand-gold bg-yellow-400/10 shadow-lg">
      <h3 className="text-xl font-bold font-serif mb-2 text-yellow-300/90">{t('blogPostPage.tldrTitle')}</h3>
      <p className="text-lg italic text-yellow-300/80">
        {content}
      </p>
    </div>
  );
};

export default TldrBox;